import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import Typography from "@mui/material/Typography"

export const List = styled("ul")`
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0 1rem;
    padding-right: 0;
    align-items: start;
    height: inherit;
    flex-wrap: wrap;
    width: 100%;
    padding-left: 0.5rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        flex-direction: column;
        flex-wrap: nowrap;
    }
`
export const Divider = styled("hr")`
    margin: 0.25rem 0.75rem;
`

export const AlphabetSection = styled(Typography)`
    background: ${({theme}) => theme.colours.utilities.backgroundAccent};
    top: 0;
    z-index: 1;
    padding: 0.4rem 1rem;
    height: 2rem;
    font-weight: ${({theme}) => theme.colours.typography.body3.fontWeight};
    font-family: ${({theme}) => `${theme.colours.typography.body3.fontFamily}, ${theme.colours.font.default}`};
`

export const TabbedFilterContainer = styled("div")`
    display: block;
`

export const PromotedBrandsContainer = styled(TabbedFilterContainer)``
